<template>
    <AuthLayout show-legal>
        <div v-if="$page.props.type === 'forgot'">
            <p class="opacity-65 text-sm mb-2">Zapište níže svůj email, kterým se přihlašujete do aplikace. Pošleme vám odkaz pro tvorbu nového hesla.</p>
            <div class="login-form" @keydown.enter="forgotPasswordForm.submit">
                <InputText id="email" placeholder="E-mail" autocomplete="email" type="email" class="w-full" v-model="forgotPasswordForm.email"
                           :invalid="forgotPasswordForm.errors['email']" />
                <small v-if="forgotPasswordForm.invalid('email')" class="text-red-500 -mt-2">{{forgotPasswordForm.errors['email']}}</small>
                <div class="form-buttons">
                    <Button label="Obnovit heslo" :loading="forgotPasswordForm.processing" @click="forgotPasswordForm.submit" class="w-full"></Button>
                </div>
            </div>
        </div>
        <div v-if="$page.props.type === 'reset'">
            <p class="opacity-65 text-sm mb-2">Níže si můžete resetovat své heslo.</p>
            <div class="login-form" @keydown.enter="resetPasswordForm.submit()">
                <InputText id="password" placeholder="Heslo" autocomplete="new-password" type="password" class="w-full" @update:model-value="resetPasswordForm.validate('password')" v-model="resetPasswordForm.password"
                           :invalid="resetPasswordForm.errors['password']" />
                <small v-if="resetPasswordForm.invalid('password')" class="text-red-500 -mt-2">{{resetPasswordForm.errors['password']}}</small>
                <InputText id="password_confirmation" placeholder="Heslo znovu" autocomplete="new-password" type="password" @update:model-value="resetPasswordForm.validate('password_confirmation')" class="w-full" v-model="resetPasswordForm.password_confirmation"
                           :invalid="resetPasswordForm.errors['password_confirmation']" />
                <small v-if="resetPasswordForm.invalid('password_confirmation')" class="text-red-500 -mt-2">{{resetPasswordForm.errors['password_confirmation']}}</small>
                <div class="form-buttons">
                    <Button label="Obnovit heslo" :loading="resetPasswordForm.processing" @click="resetPasswordForm.submit()" class="w-full"></Button>
                </div>
            </div>
        </div>
    </AuthLayout>
</template>
<script setup>
    import Button from 'primevue/button';
    import Divider from 'primevue/divider';
    import InputText from 'primevue/inputtext';
    import AuthLayout from '../components/view-components/AuthLayout.vue';

    import {
        computed, inject,
        ref
    } from 'vue';
    import {
        useToast
    } from 'primevue/usetoast';
    import {router, usePage} from "@inertiajs/vue3";
    import {useForm} from "laravel-precognition-vue-inertia";
    import GoogleIcon from "../components/GoogleIcon.vue";
    const forgotPasswordForm = useForm('POST', '/lost-password-action', {
        email: '',
    })

    const resetPasswordForm = useForm('POST', '/reset-password-action', {
        password: '',
        password_confirmation: '',
        token: usePage().props.token,
        email: usePage().props.email
    })
</script>
<style lang="scss" scoped>
    .login-form {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .form-buttons {
            display: flex;
            gap: 8px;
        }
    }
</style>
